export const sex = {
    both   : 0,
    male   : 1,
    female : 2,
};
export const numSexes = sex.female;

export const text = {
    bold      : 0,
    italic    : 1,
    underline : 2,
};

export const language = {
    english    : 1,
    french     : 2,
    arabic     : 3,
    spanish    : 4,
    russian    : 5,
    portuguese : 6,
    chinese    : 7,
    indonesian : 8,
};